module.exports = __webpack_public_path__ + "static/media/LinuxAd.a0e57285.png";